let DroppableRegionValue = /*#__PURE__*/function (DroppableRegionValue) {
  DroppableRegionValue["FullExpand"] = "full";
  DroppableRegionValue["MidExpand"] = "mid";
  DroppableRegionValue["Collapse"] = "collapsed";
  return DroppableRegionValue;
}({});

export { DroppableRegionValue };
